import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setAlert } from '../../store/generalSlice';
import { sendAmplitudeData } from '../../utilities/amplitude';
import TLButton from '../TL-Button';

function CopyReferralLinkButton() {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const Public_URL = process.env.REACT_APP_PUBLIC_URL;
  return (
    <TLButton
      className="mg-l-1"
      label="Copy Referral link"
      prefixIcon="copy"
      onClick={() => {
        sendAmplitudeData(`Copy Referral link`, {});
        navigator.clipboard.writeText(`${Public_URL}?referalcode=${user?.referal_code}&type=school`);
        dispatch(
          setAlert({
            visible: true,
            messages: ['Referral link copied successfully.'],
            type: 'success',
          })
        );
      }}
    />
  );
}

export default CopyReferralLinkButton;
